import { useCallback } from "react";
import { Flip, type ToastPosition, toast as showToast } from "react-toastify";

import { CheckIcon } from "@/assets/icons/general/Check";
import type { StatusParams } from "@/components/ui/status/shared/status";

import { Toast } from "./Toast";

type IShowToast = StatusParams & {
  position?: ToastPosition;
};

export const useToast = () => {
  const successToast = useCallback((params: IShowToast) => {
    showToast.success(
      <Toast
        variant="success"
        {...params}
        icon={CheckIcon}
      />,
      {
        position: params.position,
        transition: Flip,
        autoClose: 2000,
        closeOnClick: true,
      },
    );
  }, []);

  const errorToast = useCallback((params: IShowToast) => {
    const toastId = showToast.error(
      <Toast
        variant="error"
        {...params}
        actions={[...(params.actions || []), { text: "Dismiss", onPress: () => showToast.dismiss(toastId) }]}
      />,
      {
        position: params.position,
        transition: Flip,
        autoClose: false,
        closeOnClick: false,
      },
    );

    return toastId;
  }, []);

  const warningToast = useCallback((params: IShowToast) => {
    showToast.warning(
      <Toast
        variant="warning"
        {...params}
      />,
      {
        position: params.position,
        transition: Flip,
      },
    );
  }, []);

  const neutralToast = useCallback((params: IShowToast) => {
    showToast.info(
      <Toast
        variant="neutral"
        {...params}
      />,
      {
        position: params.position,
        transition: Flip,
        closeOnClick: true,
        autoClose: false,
      },
    );
  }, []);

  return {
    successToast,
    errorToast,
    warningToast,
    neutralToast,
  };
};
